// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1hxUN","errors":"Errors_errors__ojY7g"};